import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from "../servicios/auth.service";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private authSvc:AuthService, private route:Router)
  {

  }

  canActivate():  Promise<boolean> | boolean
  {
    return this.authSvc.verInfo().then(res=>
      {
        return res;
      }) 
  }
  
}
